import { render, staticRenderFns } from "./ConcedeDefeatButton.vue?vue&type=template&id=2fd85f8c&scoped=true&"
import script from "./ConcedeDefeatButton.vue?vue&type=script&lang=js&"
export * from "./ConcedeDefeatButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd85f8c",
  null
  
)

export default component.exports